<div
  class="w-screen h-screen flex flex-column align-items-center justify-content-center gap-4"
>
  <p-progressSpinner
    styleClass="w-5rem h-5rem"
    strokeWidth="2"
    animationDuration=".5s"
  ></p-progressSpinner>
  <div class="text-6xl text-primary text-gray-600 font-light">
    Emulator
  </div>
</div>
